import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=f53d5252&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f53d5252')) {
      api.createRecord('f53d5252', component.options)
    } else {
      api.reload('f53d5252', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=f53d5252&", function () {
      api.rerender('f53d5252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uSlHdp6mEqUh/JS/priceformat.vue"
export default component.exports